<template>
  <div>
    <div v-if="!loading">
      <b-card>
        <b-row>
          <b-col>
            <b-img
              :src="question.student.user.avatar"
              width="40%"
              class="float-right"
              rounded="circle"
              alt="Circle image"
            ></b-img>
          </b-col>
          <b-col :cols="question.owner_question ? 8 : 10">
            <div v-if="!question.editing">
              <h3 class="text-dark">
                <strong>{{question.title}}</strong>
              </h3>
              <h6 class="text-dark">{{question.question}}</h6>
              <span class="mt-3">
                <span class="text-info">
                  <small>Por {{question.student.user.name}}</small>
                </span>
                <span class="text-muted">
                  <small>
                    {{question.created_at | time}}
                    <small
                      v-if="question.updated_at != question.created_at"
                    >· (Editado)</small>
                  </small>
                </span>
              </span>
            </div>
            <div v-else>
              <EditQuestion :questionInfo="question" />
            </div>
          </b-col>
          <b-col v-if="question.owner_question ">
            <b-dropdown
              v-if="!question.editing"
              size="sm"
              class="float-right"
              right
              variant="light"
            >
              <b-dropdown-item @click="editQuestion">Editar</b-dropdown-item>
              <b-dropdown-item @click="deleteQuestion">
                <span class="text-danger">Eliminar</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </b-card>
      <div v-for="answer in question.answers" :key="answer.id">
        <b-card style="border:none!important">
          <b-row>
            <b-col />
            <b-col>
              <b-img
                :src="question.student ? question.student.user.avatar : question.trainer.user.avatar" 
                width="40%"
                class="float-right"
                rounded="circle"
                alt="Circle image"
              ></b-img>
            </b-col>
            <b-col cols="9">
              <div v-if="!answer.editing">
                <b-dropdown
                  v-if="answer.owner_answer"
                  size="sm"
                  class="float-right"
                  right
                  variant="light"
                >
                  <b-dropdown-item @click="answer.editing=true;$forceUpdate()">Editar</b-dropdown-item>
                  <b-dropdown-item @click="deleteAnswer(answer)">
                    <span class="text-danger">Eliminar</span>
                  </b-dropdown-item>
                </b-dropdown>
                <h3 class="text-dark">
                  <span v-if="answer.trainer != null">
                    <strong>{{answer.trainer.user.name}}</strong>
                    <small v-if="course_owner"> · Capacitador ·</small>
                  </span>
                  <span v-else>
                    <strong>{{answer.student.user.name}}</strong>
                  </span>
                  <span class="text-muted">
                    <small>
                      {{answer.created_at | time}}
                      <small
                        v-if="answer.updated_at != answer.created_at"
                      > · (Editado)</small>
                    </small>
                  </span>
                </h3>
                <h6 class="text-dark">{{answer.answer}}</h6>
              </div>
              <div v-else>
                <EditAnswer :answerOld="answer" />
              </div>
            </b-col>
          </b-row>
        </b-card>
        <hr />
      </div>
      <CreateAnswer :question="question" />
    </div>
    <div v-else>
      <center>
        <b-spinner style="width: 3rem; height: 3rem;" variant="warning" large></b-spinner>
        <h5 class="text-dark mt-4 mb-5">Eliminando pregunta...</h5>
      </center>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CreateAnswer from "./CreateAnswer";
import EditQuestion from "./EditQuestion";
import EditAnswer from "./EditAnswer";

export default {
  components: {
    CreateAnswer,
    EditQuestion,
    EditAnswer
  },
  data() {
    return {
      loading: false
    };
  },
  props: {
    question: Object,
    course_owner:Boolean
  },
  created() {
    this.question.answers.forEach(answer => {
      answer.editing = false;
    });

    this.question.editing = false;
    this.bus.$on("UpdateAnswers", answers => {
      this.question.answers = answers;
      this.$forceUpdate();
    });
    this.bus.$on("CancelEditQuestion", () => {
      this.question.editing = false;
      this.$forceUpdate();
    });
    this.bus.$on("UpdateQuestion", data => {
      this.question.editing = false;
      this.question.title = data.title;
      this.question.updated_at = 999;
      this.question.question = data.question;
      this.$forceUpdate();
    });
    this.bus.$on("CancelEditAnswer", answer_id => {
      this.question.answers.forEach(answer => {
        if (answer.id == answer_id) {
          answer.editing = false;
          this.$forceUpdate();
        }
      });
    });
    this.bus.$on("UpdateAnswer", data => {
      this.question.answers.forEach(answer => {
        if (answer.id == data.answer_id) {
          answer.editing = false;
          answer.answer = data.answer;
          answer.updated_at = 99;
          this.$forceUpdate();
        }
      });
    });
  },
  methods: {
    editQuestion() {
      this.question.editing = true;
      this.$forceUpdate();
    },
    deleteQuestion() {
      this.confirm({
        title: "Eliminar pregunta",
        body:
          "¿Estas seguro de eliminar tu pregunta? Esta opcion no se puede deshacer."
      }).then(value => {
        if (value) {
          this.loading = true;
          let url =
            "course/" +
            this.question.curse_id +
            "/question/" +
            this.question.id;
          this.api.delete(url).then(({ data }) => {
            this.loading = false;
            if (data.erased) {
              this.bus.$emit("UpdateQuestions", data.data_return);
              this.bus.$emit("ReturnQuestions", true);
            }
          });
        }
      });
    },
    deleteAnswer(answer) {
      this.confirm({
        title: "Eliminar respuesta",
        body:
          "¿Estas seguro de eliminar tu respuesta? Esta opcion no se puede deshacer."
      }).then(value => {
        if (value) {
          let url =
            "course/" +
            this.question.curse_id +
            "/question/" +
            this.question.id +
            "/answer/" +
            answer.id;

          this.api.delete(url).then(({ data }) => {
            this.loading = false;
            if (data.erased) {
              this.bus.$emit("UpdateQuestions", data.data_return);
              this.question.answers = this.question.answers.filter(answer_i => {
                return answer_i.id !== answer.id;
              });
            }
          });
        }
      });
    },
    confirm(data) {
      return new Promise((resolve, reject) => {
        this.$bvModal
          .msgBoxConfirm(data.body, {
            title: data.title,
            size: "md",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: "Confirmar",
            cancelTitle: "Cancelar",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            resolve(value);
          });
      });
    }
  },
  filters: {
    time(val) {
      moment.locale("es");
      return moment(val, "YYYY-MM-DD HH:mm:ss").fromNow();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/ViewAnswers.vue